import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { GenericRESTPagedClientManager } from "../../../../js/lib/manager/GenericRESTPagedClientManager";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";

export const LoanHistoryClientManager = function() {
  let instance = null;
  return {
    getInstance: (options) => {
      if(instance){
        return instance;
      }
      instance = new LoanHistoryClientManagerClass(options);
      return instance;
    }
  }
}();
class LoanHistoryClientManagerClass extends GenericRESTPagedClientManager {
  constructor(options) {
    super(
      $.extend(
        {
          resultsPanelId: options.resultsPanelId,
          restUrl: LS2PAC_CONSTANTS.restUrls.getLoanHistory,
          pageSize: 20,
        },
        options
      )
    );

    this.restOptions.cancellable = true;
    this.restOptions.cache = false;
    this.sortField = this.defaultSort = "OutDate";
    this.addListeners();
  }
  fireSearch(event) {
    this.search(
      this.currentPage * this.pageSize,
      this.pageSize,
      this.sortField
    );
  }
  resetPageCache() {
    this.pages = [];
    this.hasResults = false;
    this.currentPage = 0;
  }
  setTotalHits(totalHits) {
    this.resetPageCache();
    this.totalHits = totalHits;
  }
  getTotalCount(callback) {
    TLCRest.jsonCall(LS2PAC_CONSTANTS.restUrls.getTotalLoanHistoryCount, {
      callback: function (data) {
        TLCLogger.log("getTotalLoanHistoryCount response", data);
        callback(data.count);
      },
      cache: false,
    });
  }
  addListeners() {
    var _this = this;

    TLCEventManager.addListener(this.searchEvent, function (event) {
      _this.resetPageCache();
      _this.fireSearch(event);
      _this.addHistory(event);
    });

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onLogoutResponse,
      function (event) {
        _this.sortField = _this.defaultSort;
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onGetAllLoanHistoryRange,
      function (event) {
        var success = false,
          response = {};

        TLCRest.jsonCall(LS2PAC_CONSTANTS.restUrls.getLoanHistoryByDateRange, {
          postData: {
            startDate: event.startDate.format("yyyy-mm-dd"),
            endDate: event.endDate.format("yyyy-mm-dd"),
            includeResources: false,
          },
          callback: function (data) {
            success = true;
            response = data.loanHistory;
            TLCLogger.log("onGetAllLoanHistoryRange response", data);
          },
          finallyHandler: function () {
            TLCEventManager.fireEvent(
              LS2PAC_CONSTANTS.Events.onGetAllLoanHistoryRangeResponse,
              { success: success, data: response }
            );
          },
          timeout: 60000,
          cancellable: true,
          cache: false,
        });
      }
    );
  }
}
